import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dropdown } from 'antd';
import { PrinterOutlined } from '@ant-design/icons';
import endpoints from '../../../../api/endpoints';
import { notifyError } from '../../../../utils/notify';
import { proformaReportJobRequest, proformaReportViewerPath, canPrintProforma } from './proformaReport';

// ── Stage 6JR.1 — Proforma Print / Preview ───────────────────────────
// Creates a FRESH report job (reportCode 'erp_proforma') for the saved
// proforma, then routes to the shared report viewer (/reports/viewer/:jobId)
// — the same Crystal-Reports-style flow the subscription invoice uses. Opens
// the paginated PDF in the viewer; the user prints / saves from the browser.
// Does NOT touch the proforma save/load/calculation workflow.
//
// A split button lets the user pick the MAIN line-table area unit per print:
// the primary click prints in Sq. Metre (historical default); the caret menu
// offers Sq. Metre / Sq. Feet. The unit only changes the area column + its rate
// on the print — totals, GST and grand total are identical either way.
const UNIT_ITEMS = [
  { key: 'SQM', label: 'Print in Sq. Metre (m²)' },
  { key: 'SQFT', label: 'Print in Sq. Feet (ft²)' }
];

export default function ProformaPrintButton({ proforma, size = 'small', block = false }) {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  async function run(areaUnit) {
    if (busy || !canPrintProforma(proforma)) return;
    setBusy(true);
    try {
      const out = await endpoints.reports.createJob(proformaReportJobRequest(proforma.id, areaUnit));
      const jobId = out && out.job && out.job.id;
      if (jobId) navigate(proformaReportViewerPath(jobId));
    } catch (err) {
      notifyError(err, 'Could not open the proforma print.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <Dropdown.Button
      size={size}
      block={block}
      loading={busy}
      disabled={!canPrintProforma(proforma)}
      // Primary click = the historical default (Sq. Metre).
      onClick={(e) => { if (e && e.stopPropagation) e.stopPropagation(); run('SQM'); }}
      menu={{
        items: UNIT_ITEMS,
        onClick: ({ key, domEvent }) => { if (domEvent && domEvent.stopPropagation) domEvent.stopPropagation(); run(key); }
      }}
    >
      <PrinterOutlined /> Print
    </Dropdown.Button>
  );
}
